import React, { useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { PackagePlus, X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export { BUILTIN_CATEGORIES as PRODUCT_CATEGORIES, categoryLabelOf } from '../lib/categories';
import { useProductCategories } from '../lib/categories';
import { NewCategoryButton } from './NewCategoryButton';

// Cadastro rápido de produto (usado no lançamento de nota quando o código não existe)
export const QuickProductForm = ({ barcode, onCreated, onCancel }) => {
  const isEan = /^\d{8,14}$/.test(barcode || '');
  const categories = useProductCategories();
  const [form, setForm] = useState({ name: '', unit: 'un', cost_price: '', price: '', category: 'mercearia', barcode: isEan ? barcode : '', code: isEan ? '' : (barcode || '') });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  // Não usa <form>: este bloco fica dentro do <form> da nota (form aninhado é inválido em HTML)
  const submit = async () => {
    if (!form.name.trim()) { setError('Informe o nome do produto'); return; }
    if (!(parseFloat(form.price) > 0)) { setError('Informe o preço de venda'); return; }
    setError(''); setBusy(true);
    try {
      const payload = {
        name: form.name.trim(), unit: form.unit, category: form.category,
        cost_price: parseFloat(form.cost_price) || 0, price: parseFloat(form.price),
        barcode: form.barcode.trim() || null, code: form.code.trim() || null,
        stock_quantity: 0, min_stock: 0,
      };
      const { data } = await axios.post(`${API}/products`, payload, { withCredentials: true });
      onCreated(data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao cadastrar produto');
    } finally { setBusy(false); }
  };

  return (
    <div className="border-2 border-emerald-300 bg-emerald-50 rounded-md p-4 mb-3 space-y-3" data-testid="quick-product-form" onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); submit(); } }}>
      <div className="flex items-center justify-between">
        <p className="font-bold text-emerald-900 flex items-center gap-2"><PackagePlus size={16} /> Cadastrar produto novo · código <span className="font-mono">{barcode}</span></p>
        <button type="button" onClick={onCancel} className="text-slate-500 hover:text-slate-800" data-testid="quick-product-cancel"><X size={16} /></button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-6 gap-3">
        <div className="md:col-span-2 space-y-1"><Label className="text-xs">Nome *</Label><Input autoFocus value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="quick-product-name" /></div>
        <div className="space-y-1">
          <Label className="text-xs">Unidade *</Label>
          <select value={form.unit} onChange={(e) => setForm({ ...form, unit: e.target.value })} className="w-full h-10 px-3 rounded-md border border-slate-300 bg-white text-sm" data-testid="quick-product-unit">
            <option value="un">Unidade (un)</option><option value="kg">Quilo (kg)</option><option value="lt">Litro (lt)</option>
          </select>
        </div>
        <div className="space-y-1"><Label className="text-xs">Preço de custo</Label><Input type="number" step="0.01" min="0" value={form.cost_price} onChange={(e) => setForm({ ...form, cost_price: e.target.value })} placeholder="0,00" data-testid="quick-product-cost" /></div>
        <div className="space-y-1"><Label className="text-xs">Preço de venda *</Label><Input type="number" step="0.01" min="0.01" value={form.price} onChange={(e) => setForm({ ...form, price: e.target.value })} placeholder="0,00" data-testid="quick-product-price" /></div>
        <div className="space-y-1">
          <Label className="text-xs">Categoria *</Label>
          <div className="flex items-start gap-1">
            <select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="w-full h-10 px-3 rounded-md border border-slate-300 bg-white text-sm" data-testid="quick-product-category">
              {categories.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
            <NewCategoryButton className="!h-10 !w-10" onCreated={(value) => setForm((f) => ({ ...f, category: value }))} />
          </div>
        </div>
      </div>
      {error && <p className="text-sm text-red-600" data-testid="quick-product-error">{error}</p>}
      <div className="flex gap-2">
        <Button type="button" onClick={submit} disabled={busy} className="bg-emerald-600 hover:bg-emerald-700" data-testid="quick-product-save"><PackagePlus size={16} className="mr-2" />{busy ? 'Salvando...' : 'Cadastrar e usar na nota'}</Button>
        <Button type="button" variant="outline" onClick={onCancel}>Lançar como avulso</Button>
      </div>
    </div>
  );
};

export default QuickProductForm;
